<div class="relative ig-color-picker">
  <div
    class="example-palette-button"
    ngx-colors-trigger
    [(ngModel)]="color"
    [style.color]="color"
    (change)="onChange($event)"
    (slider)="onSlider($event)"
    (input)="onInput($event)"
    (open)="onOpen($event)"
    (close)="onClose($event)"
    colorsAnimation="popup"
  >
    <!--    <div class="ig-color-picker-preview-wrap z-[1] relative">-->
    <!--      <div class="ig-color-picker-preview">-->
    <!--        <div class="ig-color-picker-preview-background">-->
    <!--          <div class="ig-color-picker-circle" [style.background]="color"></div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <span class="ig-color-picker-shadow">{{ triggerText }}</span>-->
    <!--    </div>-->

    <div class="absolute w-8 h-8 items-center flex justify-center cursor-pointer bg-gray-800 rounded-full"
         [matTooltip]="triggerText">
      <mat-icon class="text-[14px] text-white !w-4 !h-4 !overflow-visible font-normal"
                style="-webkit-text-stroke:0 white">
        border_color
      </mat-icon>
    </div>
  </div>

  <!--  <div *ngIf="isShowIndicator"-->
  <!--       class="ig-circle absolute w-12 h-12 items-center flex justify-center left-[-13px] top-[-11px]">-->
  <!--    <div class="ig-outer-circle absolute rounded-full w-6 h-6 bg-[#71c5e95e] transition-all ">-->
  <!--    </div>-->
  <!--  </div>-->
</div>
